import axios from 'axios'
import api from '@/services/api'

// GET /header is asked for by several independent components (SiteHeader for
// the logo/menu/maintenance banner, Newsletter/ContactFrom/RegisterForm for
// the recaptcha config) on the same page load. Memoize the request so they
// share one round trip instead of each firing their own.
let headerInfoPromise = null;
export function fetchHeaderInfo() {
    if (!headerInfoPromise) {
        headerInfoPromise = axios.get(api.getUrl('/header')).then((response) => response.data).catch((error) => {
            headerInfoPromise = null;
            throw error;
        });
    }
    return headerInfoPromise;
}

// The country/currency the shopper is browsing in. Countries are admin
// managed on the backend (GET /v1/countries), so this list - and which one
// is "default" - is data-driven rather than a hardcoded NPR/USD pair.
// selectedCountry is persisted via the app-wide vuex-persistedstate plugin,
// so a guest's choice survives a refresh; a logged-in user's choice is also
// saved server-side (POST /v1/user/currency) so it follows them across devices.
const state = {
    countries: [],
    selectedCountry: null,
    recaptchaEnabled: false,
    recaptchaSiteKey: '',
}
const mutations = {
    SET_COUNTRIES (state, countries) {
        state.countries = countries;
    },
    SET_SELECTED_COUNTRY (state, country) {
        state.selectedCountry = country;
    },
    SET_RECAPTCHA_CONFIG (state, { enabled, siteKey }) {
        state.recaptchaEnabled = enabled;
        state.recaptchaSiteKey = siteKey;
    },
}
const actions = {
    async fetchCountries ({ commit, state }) {
        const response = await axios.get(api.getUrl('/countries'));
        if (response.data.success) {
            commit('SET_COUNTRIES', response.data.data);
            if (!state.selectedCountry) {
                const defaultCountry = response.data.data.find(c => c.is_default) || response.data.data[0] || null;
                commit('SET_SELECTED_COUNTRY', defaultCountry);
            }
        }
    },
    setSelectedCountry ({ commit, rootGetters }, country) {
        commit('SET_SELECTED_COUNTRY', country);
        if (rootGetters.authenticated && rootGetters.user && rootGetters.user.id) {
            axios.post(api.getUrl('/user/currency'), {
                id: rootGetters.user.id,
                country_id: country.id,
            }).catch(() => {});
        }
    },
    async fetchRecaptchaConfig ({ commit }) {
        try {
            const data = await fetchHeaderInfo();
            if (data.success) {
                commit('SET_RECAPTCHA_CONFIG', {
                    enabled: !!data.data.recaptcha_enabled,
                    siteKey: data.data.recaptcha_site_key || '',
                });
            }
        } catch (e) {
            // Leave recaptcha disabled if the config could not be loaded.
        }
    },
}
const getters = {
    countries: state => state.countries,
    selectedCountry: state => state.selectedCountry,
    selectedCountryCode: state => state.selectedCountry ? state.selectedCountry.code : 'NP',
    selectedCurrencyCode: state => state.selectedCountry ? state.selectedCountry.currency_code : 'NPR',
    selectedCurrencySymbol: state => state.selectedCountry ? state.selectedCountry.currency_symbol : 'Rs.',
    recaptchaEnabled: state => state.recaptchaEnabled,
    recaptchaSiteKey: state => state.recaptchaSiteKey,
}
export default {
    state,
    mutations,
    actions,
    getters
}
